export const scrollBar = {
    horizontal: {
        height: 10,
        slider: {
            style: {
                fill: {
                    type: "palette",
                    key: "scrollBarSliderColor"
                }
            }
        }
    },
    vertical: {
        width: 10,
        slider: {
            style: {
                fill: {
                    type: "palette",
                    key: "scrollBarSliderColor"
                }
            }
        }
    }
};
//# sourceMappingURL=scroll-bar.js.map
